<template>
  <div class="custom-invoice-wrapper">
    <InvoiceTables />
  </div>
</template>
<script>
import InvoiceTables from '@/components/invoice/forms/InvoiceTables.vue'
export default {
  name: 'InvoiceReview',
  components: {
    InvoiceTables
  }
}
</script>
<style lang="scss" scoped>
.custom-invoice-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 62vh;
  padding-right: 5px;
}
</style>
